import { render, staticRenderFns } from "./loanAmountInput.vue?vue&type=template&id=6230b48c&scoped=true"
import script from "./loanAmountInput.vue?vue&type=script&lang=js"
export * from "./loanAmountInput.vue?vue&type=script&lang=js"
import style0 from "./loanAmountInput.vue?vue&type=style&index=0&id=6230b48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230b48c",
  null
  
)

export default component.exports